import { render, staticRenderFns } from "./EventCategoriesPage.vue?vue&type=template&id=4ba3a18a&"
import script from "./EventCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./EventCategoriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports